import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { Corner, Paisley } from "../HennaMotif";

const ParallaxImage = ({ src, alt, className = "", testid }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <div ref={ref} className={`group relative overflow-hidden ${className}`}>
      <motion.img
        style={{ y }}
        src={src}
        alt={alt}
        data-testid={testid}
        className="h-[115%] w-full object-cover transition-transform duration-700 will-change-transform group-hover:scale-105"
      />
      <div className="pointer-events-none absolute inset-0 border border-gold/10" />
    </div>
  );
};

export const Gallery = () => (
  <section
    id="galeri"
    data-testid="gallery-section"
    className="relative py-32 md:py-44"
  >
    <Corner className="pointer-events-none absolute left-6 top-16 h-24 w-24 text-gold/35 md:h-32 md:w-32" />
    <Corner className="pointer-events-none absolute bottom-16 right-6 h-24 w-24 rotate-180 text-gold/35 md:h-32 md:w-32" />
    <Paisley className="pointer-events-none absolute -right-6 top-1/3 hidden h-48 w-36 rotate-6 text-gold/25 md:block" />
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <Reveal className="mb-16 flex flex-col justify-between gap-4 md:flex-row md:items-end">
        <h2 className="max-w-xl font-serif text-4xl leading-tight tracking-tight text-cream md:text-6xl">
          Bu geceyi birlikte
          <span className="italic text-gold"> yaşayacağımız </span>
          mekân
        </h2>
        <p className="max-w-xs font-sans text-sm font-light text-sand">
          POİ Boğaz Bahçe 2 · Anadolu Yakası Çatalmeşe — düğünümüzün sıcak atmosferi sizi bekliyor.
        </p>
      </Reveal>

      <div className="grid grid-cols-6 gap-4 md:gap-6">
        <Reveal className="col-span-6 md:col-span-4">
          <ParallaxImage src="/img/hall1.webp" alt="Düğün salonu genel görünüm" testid="gallery-img-1" className="aspect-[16/10]" />
        </Reveal>
        <Reveal delay={0.1} className="col-span-6 md:col-span-2">
          <ParallaxImage src="/img/hall2.jpg" alt="Bahçe oturma alanı" testid="gallery-img-2" className="aspect-[16/10] md:h-full" />
        </Reveal>
        <Reveal delay={0.18} className="col-span-6">
          <ParallaxImage src="/img/hall3.jpg" alt="Düğün salonu kuşbakışı" testid="gallery-img-3" className="aspect-[16/7]" />
        </Reveal>
      </div>
    </div>
  </section>
);
